import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Page/Home";
import PrivateRoute from "./Components/Auth";
import Admin from "./Page/Admin";
import License from "./Page/License";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Definir a rota padrão como '/' */}
        <Route index path="/" element={<Home />} />
        <Route path="/license" element={<License/>} />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Admin />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};
export default Router;
